'use client';

import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const counterVariants = tv({
  base: 'inline-flex min-w-fit items-center justify-center rounded-full font-normal bg-gray-500 text-base-white',
  variants: {
    variant: {
      default: 'px-1 py-[0.125rem]',
      icon: 'p-0',
    },
    size: {
      sm: 'w-4 h-4 text-xs leading-4',
      md: 'w-5 h-5 text-base leading-6',
      lg: 'w-7 h-7 text-xl',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'sm',
  },
});

export type CounterProps = {
  characters?: string | number;
  type?: 'number' | 'icon';
  icon?: JSX.Element;
} & React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof counterVariants>;

export const Counter = React.forwardRef<HTMLDivElement, CounterProps>(
  (props, ref) => {
    const content = props.type === 'number' ? props.characters : props.icon;
    return (
      <div
        className={cn(
          counterVariants({
            variant: props.variant,
            size: props.size,
            className: props.className,
          }),
        )}
        ref={ref}
        {...props}
      >
        {content}
      </div>
    );
  },
);

Counter.displayName = 'Counter';
